export const NUMBER_OF_RESULTS = 1;
export const MAX_BUILDINGS_TO_RETURN = 6;
export const MIN_BUILDINGS_TO_RETURN = 3;
export const BUILDINGS_NEAR_ME_EXPERIMENT = 'buildings_near_me';
export const BUILDINGS_NEAR_ME_EVENTS = {
  buildings: 'buildings_near_me_building_cards',
  globalReach: 'buildings_near_me_global_reach'
};
export const nearbyBuildingsSectionContainerId = 'home-nearby-buildings__container';
export const nearbyBuildingsSlider = '#nearby-buildings-slider';

export const nearbyBuildingsSelectors = {
  activeSection: 'home-nearby-buildings--active',
  section: '.home-nearby-buildings',
  slider: '#nearby-buildings-slider',
  sliderList: '.glide__slides',
  sliderCard: '.nearby-buildings-slider__card',
  slideImage: '.ray-card__image',
  slideTitle: '.ray-card__heading',
  slideLink: '.nearby-buildings__card-link',
  slideNeighbor: '.nearby-buildings__neighbor',
  locationTotal: '.nearby-buildings__total',
  locationName: '.nearby-buildings__location-name',
  locationCity: '.nearby-buildings__city-name',
  locationLink: '.nearby-buildings__location-link',
  loader: '#home-nearby-buildings__container',
  cityName: '.nearby-buildings__city',
  globalReach: '.home-nearby-buildings__global-reach'
};
